<template>
  <b-card>
    <b-row style="margin-bottom: 10px;">
      <label class="custom-font mb-1"><b>Upcoming Due Milestone Summary [Next 30 Days]</b></label>

      <div class="button-style">
        <b-button
          class="flex-shrink-0 mr-1"
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          variant="primary"
          @click="goMilestones"
        >
        <feather-icon icon="ClipboardIcon" />

        </b-button>
      </div>
    </b-row>
    <b-table responsive="sm" :items="items" sticky-header height="300px" />
  </b-card>
</template>

<script>
import {
  BCard,
  BAvatar,
  BBadge,
  BPagination,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BDropdown,
  BDropdownItem,
  BButton,
  BForm,
  BModal,
  BSpinner,
  BCol,
  BRow,
  BFormDatepicker,
  BFormTextarea,
  BLink,
  BMedia,
  BMediaAside,
  BMediaBody,
  BCardText,
  BTable,
} from "bootstrap-vue";
import { VueGoodTable } from "vue-good-table";
import Ripple from "vue-ripple-directive";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { mapGetters } from "vuex";
import { EventBus } from "@/helpers/event-bus";

export default {
  name: "UpcomingDueMilestoneWidget",
  components: {
    BForm,
    BButton,
    BCard,
    VueGoodTable,
    BAvatar,
    BBadge,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    ValidationProvider,
    ValidationObserver,
    BModal,
    BSpinner,
    BCol,
    BRow,
    BFormDatepicker,
    BFormTextarea,
    BLink,
    BMedia,
    BMediaAside,
    BMediaBody,
    BCardText,
    BTable,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      // filter
      items: [
        {
          deadline: "",
          title: "No Data Found",
          amount: "",
          payment_type:  "",
        },
      ],
    };
  },

  computed: {
    ...mapGetters({
      permissions: "userModule/getPermissions",
    }),
  },

  async created() {
    try {
      this.loadItems();
    } catch (error) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: "Error",
          icon: "BellIcon",
          variant: "danger",
          text: error?.response?.data?.message,
        },
      });
    }
  },
  methods: {
    formatDate(value) {
      if (value) {
        return this.$moment(value).format("MMM Do YYYY");
      }
      return "Not Set";
    },

    goMilestones() {
      this.$router.push({
        name: "admin-milestones",
      });
    },

    // onShowPage(id) {
    //   this.$router.push({
    //     name: "admin-attendance-details",
    //     params: { id },
    //   });
    // },

    async getMilestoneData() {
      return await this.$api.get("api/dashboard/upcoming/due/milestones");
    },

    async loadItems() {
      try {
        const milestoneData = await this.getMilestoneData();

        if (milestoneData?.data?.data.length > 0) {
          this.items = milestoneData?.data?.data.map((item) => {
            return {
              deadline: this.formatDate(item?.date),
              title: item?.title,
              amount: item?.amount +" "+(item?.currency),
              payment_type:  item?.payment_type ,
            };
          });
        }

      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Warning",
            icon: "BellIcon",
            variant: "warning",
            text: error?.response?.data?.message,
          },
        });
      }
    },
  },
};
</script>

    <style lang="scss">
@import "@core/scss/vue/libs/vue-good-table.scss";
.table-custom-style-att {
  white-space: nowrap !important;
  min-height: 140px !important;
  tr,
  th,
  td {
    vertical-align: middle !important;
    text-align: center !important;
    font-size: 12px !important;
  }
}
.custom-font {
  font-size: 13px !important;
}
</style>
